import React, { useEffect, useState } from "react";
import api from "../../api/api";
import Create from "./Create";
import Edit from "./Edit";
import Alerts from "../Alerts";
import { CircularProgress } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const View = () => {
  const [cards, setCards] = useState("");
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [item, setItem] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [warning, setWarning] = useState({});

  useEffect(() => {
    if (cards !== "") return;
    const fetchFeaturedProducts = async () => {
      try {
        const response = await api.get("products/featured");
        setFeaturedProducts(response.data);
      } catch (error) {
        console.error("Erro ao buscar produtos destacados:", error);
        setWarning({
          type: "error",
          message: "Falha ao carregar os destaques do servidor!",
        });
        handleOpenSnackbar();
      }
    };

    fetchFeaturedProducts();
  }, [cards]);

  const handleOpenSnackbar = () => {
    setOpenSnackbar(true);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  return (
    <div className="p-2">
      <div className="flex justify-start mb-6">
        <button
          onClick={() => {
            cards === "" ? setCards("create") : setCards("");
          }}
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-700 transition-colors flex items-center gap-2"
        >
          {cards === "" ? (
            <div className="flex items-center gap-2">
              <AddIcon sx={{ fontSize: 16, color: "white" }} />
              Criar Destaque
            </div>
          ) : (
            <div className="flex items-center gap-2">
              <ArrowBackIcon sx={{ fontSize: 16, color: "white" }} />
              Voltar
            </div>
          )}
        </button>
      </div>

      {cards === "create" ? (
        <Create
          setWarning={setWarning}
          handleOpenSnackbar={handleOpenSnackbar}
          setCards={setCards}
        />
      ) : cards === "edit" ? (
        <Edit
          setWarning={setWarning}
          handleOpenSnackbar={handleOpenSnackbar}
          item={item}
          setCards={setCards}
        />
      ) : featuredProducts.length > 0 ? (
        <div className="space-y-8">
          {featuredProducts
            .sort((a, b) => {
              if (a.type === "FOR_YOU" && b.type === "FOR_BUSINESS") return -1;
              if (a.type === "FOR_BUSINESS" && b.type === "FOR_YOU") return 1;
              return 0;
            })
            .map((featured, index) => (
              <div
                key={index}
                className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-200"
              >
                <div className="bg-gradient-to-r from-blue-50 to-blue-50 p-6 border-b border-gray-200">
                  <div className="flex justify-between items-center gap-4">
                    <div className="flex-1">
                      <h2 className="text-2xl font-bold text-gray-800 mb-2">
                        {featured.title}
                      </h2>
                      <div className="flex flex-wrap gap-3 text-sm">
                        <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full font-medium">
                          Posição: {featured.position}
                        </span>
                        <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full font-medium">
                          Tipo:{" "}
                          {featured.type === "FOR_YOU"
                            ? "Para você"
                            : "Para salão"}
                        </span>
                        {featured.href && (
                          <span className="bg-purple-100 text-purple-800 px-3 py-1 rounded-full font-medium">
                            Link: {featured.href}
                          </span>
                        )}
                        <span className="bg-gray-100 text-gray-800 px-3 py-1 rounded-full font-medium">
                          {featured.products?.length || 0} Produtos
                        </span>
                      </div>
                    </div>
                    <button
                      onClick={() => {
                        setCards("edit");
                        setItem(featured);
                      }}
                      className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-700 transition-colors flex items-center gap-2"
                    >
                      <svg
                        className="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                        />
                      </svg>
                      Editar Card
                    </button>
                  </div>
                </div>

                <div className="p-4 sm:p-10">
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                    {featured.products?.map((product) => (
                      <div
                        key={product.id}
                        className="group relative bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-all duration-300 hover:border-blue-300 h-full flex flex-col"
                      >
                        <div className="flex-1 overflow-hidden bg-gray-50">
                          <img
                            src={
                              product.imgUrl?.[0] ||
                              "https://via.placeholder.com/300x300?text=Imagem+não+disponível"
                            }
                            alt={product.name || "Produto"}
                            className="w-full h-64 object-contain object-center group-hover:scale-105 transition-transform duration-300"
                            onError={(e) => {
                              e.target.src =
                                "https://via.placeholder.com/300x300?text=Imagem+não+disponível";
                            }}
                          />
                        </div>

                        <div className="p-4">
                          <h3 className="text-lg font-semibold text-gray-800 mb-2 line-clamp-2">
                            {product.name}
                          </h3>
                          <p className="text-gray-600 text-sm mb-3 line-clamp-2">
                            {product.shortDesc || "Descrição não disponível"}
                          </p>
                          <div className="flex items-center justify-between">
                            <div>
                              <span className="text-gray-900 font-medium">
                                Preço:{" "}
                              </span>
                              <span className="text-gray-600">
                                {product.customerPrice
                                  ? `R$ ${product.customerPrice}`
                                  : "Consultar"}
                              </span>
                            </div>
                            {/* <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
                              #{product.id}
                            </span> */}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  {(!featured.products || featured.products.length === 0) && (
                    <div className="text-center py-8">
                      <div className="text-gray-400 mb-4">
                        <svg
                          className="w-16 h-16 mx-auto"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={1}
                            d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                          />
                        </svg>
                      </div>
                      <p className="text-gray-500 text-lg">
                        Nenhum produto encontrado neste destaque
                      </p>
                    </div>
                  )}
                </div>
              </div>
            ))}
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center h-64">
          <CircularProgress size={60} />
          <p className="mt-4 text-gray-600">Carregando destaques...</p>
        </div>
      )}

      <Alerts
        open={openSnackbar}
        handleClose={handleCloseSnackbar}
        type={warning.type}
        message={warning.message}
      />
    </div>
  );
};

export default View;
